/**
 * Custom Check Validator Plugin
 */

import createCustomCheckValidator from './plugin';

export { createCustomCheckValidator };
export default createCustomCheckValidator;
